import React, { useEffect, useState } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MtnMomoIzbPartnership = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">𝗠𝗧𝗡 𝗠𝗼𝗯𝗶𝗹𝗲 𝗠𝗼𝗻𝗲𝘆 𝗭𝗮𝗺𝗯𝗶𝗮 𝗮𝗻𝗱 𝗜𝗻𝗱𝗼 𝗭𝗮𝗺𝗯𝗶𝗮 𝗕𝗮𝗻𝗸 𝗔𝗻𝗻𝗼𝘂𝗻𝗰𝗲 𝗦𝗲𝗮𝗺𝗹𝗲𝘀𝘀 𝗠𝗼𝗠𝗼 𝗣𝗮𝘆𝗺𝗲𝗻𝘁𝘀 𝗼𝗻 𝗔𝗹𝗹 𝗜𝗭𝗕 𝗣𝗢𝗦 𝗧𝗲𝗿𝗺𝗶𝗻𝗮𝗹𝘀</h1>

                    <p className="pb-3">MTN Mobile Money Zambia and Indo Zambia Bank (IZB) have announced a strategic partnership that enables MoMo MTN customers to make seamless payments across all IZB Point of Sale (POS) terminals nationwide. This collaboration marks a significant step in strengthening digital interoperability, enhancing customer convenience, and advancing Zambia's move toward a cashless economy.</p>

                    <p className="pb-3">MTN Mobile Money CEO, Mr. Komba Malukutila, described the initiative as a major milestone toward a fully interoperable digital payments ecosystem that supports financial inclusion and innovation. He added that MTN MoMo is evolving beyond traditional mobile money by offering smarter, more inclusive, and more integrated services for customers and businesses across Zambia.</p>

                    <p className="pb-3">IZB Managing Director, Mr. Brajesh Kumar Singh, reaffirmed the bank's commitment to digital transformation, noting that the integration aligns with IZB's mission to provide secure, convenient, and accessible electronic payments nationwide. He emphasized that customers can now pay effortlessly using their MTN MoMo wallets on any IZB POS terminal reducing reliance on cash and ensuring faster, safer checkout experiences.</p>

                    <p className="pb-3">Mr. Singh also highlighted IZB's recent digital upgrades, including enhancements to the Core Banking System, the IZB NXT Digital Banking suite, Agency Banking, ERP integrations, QR payment capabilities, and the Indo Wallet. These advancements have strengthened the bank's capacity to deliver seamless and efficient payment solutions for both customers and merchants.</p>

                    <p className="pb-3">This partnership supports Zambia's national Agenda of increasing financial inclusion, growing digital commerce and promoting a secure and interoperable payment system.</p>

                    <p className="pb-3"><b><em>#MTNMoMo #IndoZambiaBank #DigitalPayments #FinancialInclusion #CashlessZambia #Partnership #Innovation #SeamlessPayments</em></b></p>

                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_9651.jpg.jpeg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/5W1A3600.jpg.jpeg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/5W1A3690.jpg.jpeg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_9622.jpg.jpeg" />
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default MtnMomoIzbPartnership;
